module.exports = __webpack_public_path__ + "static/media/6.1721a2d7.svg";